<template>
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28Z"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M28.2929 21.2929C28.6834 20.9024 29.3166 20.9024 29.7071 21.2929L35.7071 27.2929C36.0976 27.6834 36.0976 28.3166 35.7071 28.7071L29.7071 34.7071C29.3166 35.0976 28.6834 35.0976 28.2929 34.7071C27.9024 34.3166 27.9024 33.6834 28.2929 33.2929L32.5858 29H21C20.4477 29 20 28.5523 20 28C20 27.4477 20.4477 27 21 27H32.5858L28.2929 22.7071C27.9024 22.3166 27.9024 21.6834 28.2929 21.2929Z" fill="#12122C"/>
  </svg>
</template>

<script setup lang="ts">

</script>